import { render, staticRenderFns } from "./f-data-button-actions.vue?vue&type=template&id=592a0b9a&scoped=true"
import script from "./f-data-button-actions.vue?vue&type=script&lang=js"
export * from "./f-data-button-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592a0b9a",
  null
  
)

export default component.exports